export type GenericObject = Record<string, any>;

export const getActualLoanData = (data?: any, formikProps?: any): GenericObject => {
  const loanData = formikProps?.values || data || {};
  return loanData?.valueData || loanData || {};
};

export const resolveEssPayload = (actualData?: GenericObject): GenericObject | null => {
  if (!actualData) {
    return null;
  }

  if (actualData.formattedEssRequestPayload && typeof actualData.formattedEssRequestPayload === 'object') {
    return actualData.formattedEssRequestPayload as GenericObject;
  }

  const payload = actualData.essRequestPayload;
  if (typeof payload === 'string' && payload.trim()) {
    try {
      return JSON.parse(payload) as GenericObject;
    } catch (error) {
      return null;
    }
  }

  if (payload && typeof payload === 'object') {
    return payload as GenericObject;
  }

  return null;
};

export const toNumber = (value: any): number => {
  if (value === null || value === undefined || value === '') {
    return 0;
  }

  const parsed = typeof value === 'number' ? value : parseFloat(String(value));
  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatAmount = (value: any): string =>
  toNumber(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const getLoanApplicationReference = (actualData: GenericObject, essPayload: GenericObject | null): string => {
  return (
    actualData?.essLoanApplicationNumber ||
    actualData?.applicationNumber ||
    essPayload?.applicationNumber ||
    'N/A'
  );
};

export const getEmployeeName = (essPayload: GenericObject | null): string => {
  if (!essPayload) {
    return 'N/A';
  }

  if (essPayload.employeeName) {
    return String(essPayload.employeeName);
  }

  const names = [essPayload.firstName, essPayload.middleName, essPayload.lastName]
    .filter(Boolean)
    .map((value: any) => String(value).trim())
    .filter(Boolean);

  return names.length > 0 ? names.join(' ') : 'N/A';
};
